<section [style.fontSize]="fontSize|async" [style.paddingTop]="topPadding|async">
  OFW loans <br/>
  made easy
</section>
<div *ngIf="isCebu|async" fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
  <span>CEBU BRANCH NOW OPEN!</span>
</div>
